(function () {
  if (window.__psPacks) { window.__psPacks.init(); return; }
  var SIZES = [
    { id: 58279181615486, name: 'S', hint: '7,5–17,5 kg' },
    { id: 58279181648254, name: 'M', hint: '17,5–30 kg' },
    { id: 58279181681022, name: 'L', hint: '30–42,5 kg' }
  ];
  var GIFT_ID = 58279187677566;
  var GIFT_IMG = 'https://cdn.shopify.com/s/files/1/1026/5074/1118/files/petsawyer-regalo-miniatura.jpg?v=1792595527&width=120';
  var GUIDE_IMG = 'https://cdn.shopify.com/s/files/1/1026/5074/1118/files/petsawyer-03-tallas.jpg?v=1792595528&width=1000';
  var THUMB = 'https://cdn.shopify.com/s/files/1/1026/5074/1118/files/petsawyer-01-principal.jpg?v=1792595529&width=120';
  var SIZE_IDS = SIZES.map(function (s) { return s.id; });
  var PACKS = [
    { qty: 1, name: '1 orejera', sub: 'Para un perro', now: '24,95 €', was: '39,95 €', off: '-38%' },
    { qty: 2, name: 'Pack 2 orejeras', sub: '22,48 € por orejera', save: 'Ahorras 4,95 € + 2 regalos', now: '44,95 €', was: '79,90 €', off: '-44%', badge: 'MEJOR OFERTA', gift: true }
  ];

  function scopeOf(el) { return el.closest('product-info') || el.closest('.shopify-section') || el.closest('section') || el.parentNode; }

  function openGuide() {
    var m = document.createElement('div'); m.className = 'ps-modal';
    m.innerHTML = '<button type="button" aria-label="Cerrar">×</button><img src="' + GUIDE_IMG + '" alt="Guía de tallas Pet Sawyer">';
    m.addEventListener('click', function (e) { if (e.target === m || e.target.tagName === 'BUTTON') m.remove(); });
    document.body.appendChild(m);
  }

  function syncImage(scope, sizeIdx) {
    var name = SIZES[sizeIdx].name;
    var input = scope.querySelector('variant-selects input[value="' + name + '"], variant-radios input[value="' + name + '"]');
    if (input && !input.checked) { input.click(); }
  }

  function build(box) {
    var scope = scopeOf(box);
    if (scope.classList) scope.classList.add('ps-scope');
    if (!document.getElementById('ps-packs')) box.id = 'ps-packs';
    var defQty = parseInt(box.getAttribute('data-default') || '2', 10);
    var defIdx = 0; PACKS.forEach(function (p, i) { if (p.qty === defQty) defIdx = i; });
    var state = { active: defIdx, picks: PACKS.map(function (p) { var a = []; for (var i = 0; i < p.qty; i++) a.push(null); return a; }) };
    box.innerHTML = '';
    var title = document.createElement('p'); title.className = 'ps-packs__title'; title.textContent = 'Elige tu pack y su talla'; box.appendChild(title);
    var guide = document.createElement('button'); guide.type = 'button'; guide.className = 'ps-guide'; guide.textContent = '📏 ¿Qué talla elijo? Ver guía de tallas';
    guide.addEventListener('click', openGuide); box.appendChild(guide);

    PACKS.forEach(function (p, pi) {
      var card = document.createElement('div');
      card.className = 'ps-pack'; card.setAttribute('role', 'button'); card.setAttribute('tabindex', '0');
      card.innerHTML =
        (p.badge ? '<span class="ps-pack__badge">' + p.badge + '</span>' : '') +
        '<div class="ps-pack__head"><span class="ps-pack__radio"></span>' +
        '<div class="ps-pack__main"><div class="ps-pack__name">' + p.name + '</div><div class="ps-pack__sub">' + p.sub + '</div>' +
        (p.save ? '<span class="ps-pack__save">' + p.save + '</span>' : '') + '</div>' +
        '<div class="ps-pack__price"><div class="ps-pack__now">' + p.now + '</div><div class="ps-pack__was">' + p.was + '</div>' + (p.off ? '<span class="ps-pack__off">' + p.off + '</span>' : '') + '</div></div>' +
        (p.gift ? '<div class="ps-pack__gift"><img src="' + GIFT_IMG + '" alt="" width="52" height="52" loading="lazy"><div><b>🎁 + 2 guías de regalo (valoradas en 29 €)</b><span>Guía antiansiedad + Plan de 7 días, en PDF</span></div></div>' : '') +
        '<div class="ps-pack__sizes"></div><p class="ps-pack__err">Elige la talla' + (p.qty > 1 ? ' de cada orejera' : '') + ' para continuar</p>';
      var wrap = card.querySelector('.ps-pack__sizes');
      for (var r = 0; r < p.qty; r++) {
        var row = document.createElement('div'); row.className = 'ps-size';
        row.innerHTML = '<span class="ps-size__label">' + (p.qty > 1 ? 'Talla orejera ' + (r + 1) : 'Talla') + '</span><div class="ps-size__opts"></div>';
        var opts = row.querySelector('.ps-size__opts');
        SIZES.forEach(function (s, si) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'ps-opt';
          b.setAttribute('data-row', r); b.setAttribute('data-size', si);
          b.innerHTML = '<b>' + s.name + '</b><small>' + s.hint + '</small>';
          opts.appendChild(b);
        });
        wrap.appendChild(row);
      }
      card.addEventListener('click', function (e) {
        var opt = e.target.closest('.ps-opt');
        if (opt) {
          e.stopPropagation();
          var row = +opt.getAttribute('data-row'), si = +opt.getAttribute('data-size');
          state.picks[pi][row] = si; state.active = pi; card.classList.remove('has-err'); render();
          if (row === 0) syncImage(scope, si);
          return;
        }
        if (state.active !== pi) { state.active = pi; render(); }
      });
      card.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === card) { e.preventDefault(); card.click(); } });
      box.appendChild(card);
    });

    var note = document.createElement('p'); note.className = 'ps-packs__note';
    note.textContent = 'En el pack puedes elegir una talla distinta para cada orejera. No apto para perros de menos de 7,5 kg.'; box.appendChild(note);

    function render() {
      box.querySelectorAll('.ps-pack').forEach(function (card, pi) {
        card.classList.toggle('is-active', pi === state.active);
        card.querySelectorAll('.ps-opt').forEach(function (o) {
          o.classList.toggle('is-on', state.picks[pi][+o.getAttribute('data-row')] === +o.getAttribute('data-size'));
        });
      });
    }
    render();
    box.__psItems = function () {
      var picks = state.picks[state.active];
      if (picks.some(function (x) { return x === null; })) return null;
      var counts = {};
      picks.forEach(function (si) { var id = SIZES[si].id; counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
      if (PACKS[state.active].gift) items.push({ id: GIFT_ID, quantity: 1 });
      return items;
    };
    box.__psShowErr = function () {
      var card = box.querySelectorAll('.ps-pack')[state.active];
      card.classList.add('has-err');
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    box.setAttribute('data-ready', '1');
    sticky(box);
  }

  function addToCart(box, btn) {
    var items = box.__psItems();
    if (!items) { box.__psShowErr(); return; }
    if (box.__psBusy) return; box.__psBusy = true;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var spinner = btn ? btn.querySelector('.loading__spinner') : null;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    if (spinner) spinner.classList.remove('hidden');
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    var body = { items: items };
    if (cart) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    function done() {
      box.__psBusy = false;
      if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
      if (spinner) spinner.classList.add('hidden');
    }
    fetch(addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status !== 200) throw new Error(res.description || 'add');
        if (!cart || !res.sections || !res.sections['cart-drawer']) { window.location.href = cartUrl; return; }
        try {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && res.sections['cart-icon-bubble']) {
            var d = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
            var inner = d.querySelector('.shopify-section') || d.body;
            bubble.innerHTML = inner.innerHTML;
          }
        } catch (e) {}
        cart.classList.remove('is-empty');
        if (typeof cart.setActiveElement === 'function' && btn) cart.setActiveElement(btn);
        try { cart.renderContents(res); } catch (e) { window.location.href = cartUrl; return; }
        cart.classList.remove('is-empty');
      })
      .catch(function () { window.location.href = cartUrl; })
      .finally(done);
  }

  /* El regalo solo puede ir con 2 o más orejeras */
  var fixing = false;
  function checkGift() {
    if (fixing) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = 0, gift = null;
      c.items.forEach(function (it) { if (SIZE_IDS.indexOf(it.variant_id) > -1) n += it.quantity; if (it.variant_id === GIFT_ID) gift = it; });
      var want = n >= 2 ? 1 : 0;
      if (gift && gift.quantity !== want) {
        fixing = true;
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: gift.key, quantity: want }) })
          .then(function () { fixing = false; window.location.reload(); }).catch(function () { fixing = false; });
      }
    }).catch(function () {});
  }

  function sticky(box) {
    if (document.querySelector('.ps-sticky')) return;
    var bar = document.createElement('div'); bar.className = 'ps-sticky';
    bar.innerHTML = '<img src="' + THUMB + '" alt="" width="46" height="46"><div class="ps-sticky__txt"><b>Orejeras anti-ruido · desde 24,95 €</b><span>🎁 2 regalos con el Pack 2</span></div><a href="#ps-packs">Comprar ahora</a>';
    bar.querySelector('a').addEventListener('click', function (e) {
      e.preventDefault();
      var t = document.getElementById('ps-packs'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    document.body.appendChild(bar);
    var btn = scopeOf(box).querySelector('.product-form__submit');
    var ticking = false;
    function inView(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }
    function update() {
      ticking = false;
      var show = window.scrollY > 250 && !inView(box) && !inView(btn);
      bar.classList.toggle('is-on', show);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boxFor(el) {
    var found = null;
    document.querySelectorAll('.ps-packs[data-ready]').forEach(function (b) {
      var s = scopeOf(b);
      if (s.contains(el) || (el.id && s.querySelector('[form="' + el.id + '"]'))) found = b;
    });
    return found;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"], .product-form__submit');
    if (!btn) return;
    var f = btn.form || btn.closest('form');
    if (!f || (f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    var box = boxFor(btn); if (!box) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addToCart(box, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    if ((e.target.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    var box = boxFor(e.target); if (!box) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addToCart(box, e.target.querySelector('button[name="add"], .product-form__submit'));
  }, true);

  /* Estrellas en amarillo: envuelve los ★ de los textos del producto */
  function starify() {
    if (!document.getElementById('ps-star-css')) {
      var st = document.createElement('style'); st.id = 'ps-star-css';
      st.textContent = '.ps-star{color:#FFB400;font-size:1.3em;letter-spacing:2px;vertical-align:-0.05em}';
      document.head.appendChild(st);
    }
    var roots = document.querySelectorAll('product-info, .product, .featured-product');
    roots.forEach(function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
      while ((n = w.nextNode())) { if (n.nodeValue.indexOf('★') > -1 && !(n.parentNode.closest && n.parentNode.closest('.ps-star, .ps-packs, script, style'))) list.push(n); }
      list.forEach(function (t) {
        var parts = t.nodeValue.split(/(★+)/), frag = document.createDocumentFragment();
        parts.forEach(function (p) {
          if (!p) return;
          if (p.charAt(0) === '★') { var sp = document.createElement('span'); sp.className = 'ps-star'; sp.textContent = p; frag.appendChild(sp); }
          else frag.appendChild(document.createTextNode(p));
        });
        t.parentNode.replaceChild(frag, t);
      });
    });
  }

  function init() { document.querySelectorAll('.ps-packs:not([data-ready])').forEach(build); starify(); }
  window.__psPacks = { init: init, checkGift: checkGift };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  checkGift();
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(checkGift, 300); }); } catch (e) {}
  }
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('cart-drawer, cart-items')) setTimeout(checkGift, 800); });
})();
